export default "__VITE_ASSET__c05l0eSj__"